"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InvestorProfileSummaryGraphics;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _InvestorProfileWizardCalc = require("./InvestorProfileWizardCalc.config");
var _Moderate = _interopRequireDefault(require("./svg/Moderate"));
var _Growth = _interopRequireDefault(require("./svg/Growth"));
var _Conservative = _interopRequireDefault(require("./svg/Conservative"));
var _ShortTerm = _interopRequireDefault(require("./svg/ShortTerm"));
var _ModerateGrowth = _interopRequireDefault(require("./svg/ModerateGrowth"));
var _GreenDot = _interopRequireDefault(require("./svg/GreenDot"));
var _PurpleDot = _interopRequireDefault(require("./svg/PurpleDot"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function InvestorProfileSummaryGraphics(_ref) {
  var {
    finalScore
  } = _ref;
  (0, _react.useEffect)(() => {
    // If sideContent is rendered on the bottom then we want to scroll straight to the top of the sideContent
    /* istanbul ignore next */
    if (window.outerWidth < 768) {
      document.getElementById('investorGraphics').scrollIntoView();
    }
  });
  var svg = null;
  // Grab proper svg based on finalScore
  switch (finalScore) {
    case 0:
      svg = /*#__PURE__*/_react.default.createElement(_ShortTerm.default, null);
      break;
    case 1:
      svg = /*#__PURE__*/_react.default.createElement(_Conservative.default, null);
      break;
    case 2:
      svg = /*#__PURE__*/_react.default.createElement(_Moderate.default, null);
      break;
    case 3:
      svg = /*#__PURE__*/_react.default.createElement(_ModerateGrowth.default, null);
      break;
    case 4:
      svg = /*#__PURE__*/_react.default.createElement(_Growth.default, null);
      break;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    id: "investorGraphics",
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, null, /*#__PURE__*/_react.default.createElement("h3", null, "Investor Profile"), /*#__PURE__*/_react.default.createElement("h2", null, _InvestorProfileWizardCalc.investorProfiles[finalScore].type), /*#__PURE__*/_react.default.createElement("p", null, _InvestorProfileWizardCalc.investorProfiles[finalScore].desc), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, svg), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "calc--info-text row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-7 "
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_GreenDot.default, null), "\xA0Cash/Bonds")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-5 mm-text-right"
  }, /*#__PURE__*/_react.default.createElement("span", null, _InvestorProfileWizardCalc.investorProfiles[finalScore].bondPct))), /*#__PURE__*/_react.default.createElement("div", {
    className: "calc--info-text row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-7 "
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_PurpleDot.default, null), "\xA0Stocks")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-5 mm-text-right"
  }, /*#__PURE__*/_react.default.createElement("span", null, _InvestorProfileWizardCalc.investorProfiles[finalScore].stockPct)))))), /*#__PURE__*/_react.default.createElement("br", null));
}